module.exports = __webpack_public_path__ + "static/media/GKEPB.fe159770.svg";